import moment from "moment"

import {
    ATTACHMENT_ITEM_SAVE_RESPONSE,
    ATTACHMENT_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case ATTACHMENT_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case ATTACHMENT_ITEM_SAVE_RESPONSE:
            // need to remap some of the fields as they are not the same in the
            // GET list response as the POST response due to Toplink
            return {
                ...state,
                [data.attachment_id]: {
                    ...data,
                    id: data.attachment_id,
                    url: data.attachment_url,
                    title: data.attachment_title,
                    time: moment().unix()
                }
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
